import { Document, Packer } from 'docx';

// Utils
import { generateAgilityIODocx } from '@/components/template/resume/AgilityIO/docx';
import { generateDefaultDocx } from '@/components/template/resume/Default/docx';
import { showErrorToast } from '@/utils/errorHandlers';

// Constants
import { ERROR_MESSAGES } from '@/constants';

// Types
import { TemplateProps } from '@/components/template/resume/type';

/** Template ID to builder mapping */
const DOCX_BUILDERS: Record<
  string,
  (data: TemplateProps['data']) => Promise<Document>
> = {
  '1': generateDefaultDocx,
  '2': generateAgilityIODocx,
};

/**
 * Generates a DOCX file and triggers a browser download
 */
export const downloadDOCX = async (
  data: TemplateProps['data'],
  fileName: string,
  templateId = '2',
): Promise<void> => {
  let url = '';

  try {
    const generateDocx = DOCX_BUILDERS[templateId] ?? generateAgilityIODocx;
    const doc = await generateDocx(data);
    const blob = await Packer.toBlob(doc);

    url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
  } catch {
    showErrorToast(ERROR_MESSAGES.DOWNLOAD_FILE_FAILED);
  } finally {
    if (url) URL.revokeObjectURL(url);
  }
};
